import React, { ComponentProps, memo } from 'react'

import { Theme } from '@emotion/react'

import { FlexBox } from './FlexBox'
import { ProgressBar } from './ProgressBar'
import { TextBold } from './Text'

interface DefaultProgressBarProps extends ComponentProps<typeof FlexBox> {
  currentStep: number
  stepCount: number
  stepLabel?: string
  customLabel?: string
  color?: keyof Theme['ui']['colors']
}

type RequireStepLabelOrCustomLabel<T> =
  | (T & { stepLabel: string; customLabel?: undefined })
  | (T & { stepLabel?: undefined; customLabel: string })

type DefaultProgressBarPropsStrict = RequireStepLabelOrCustomLabel<
  Omit<DefaultProgressBarProps, 'stepLabel' | 'customLabel'>
>

export const DefaultProgressBar = memo(
  ({
    currentStep,
    stepCount,
    stepLabel,
    customLabel,
    color = 'navy.100',
    ...rest
  }: DefaultProgressBarPropsStrict) => {
    const percentage = (currentStep / stepCount) * 100

    return (
      <FlexBox
        {...{
          w: '100px',
          jc: 'flex-end',
          fd: 'column',
          ai: 'end',
          flex: 'initial',
          gap: 'sm',
          ...rest,
        }}>
        {customLabel ? (
          <TextBold {...{ color }}>{customLabel}</TextBold>
        ) : (
          <TextBold
            {...{
              color,
            }}>{`${stepLabel} ${currentStep}/${stepCount}`}</TextBold>
        )}
        <ProgressBar {...{ percentage }} />
      </FlexBox>
    )
  },
)
